module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section03_02_beach-photo-e806af14370df078aede7f6aff21ec2a.jpg";